export default __webpack_public_path__ + "static/media/finguerGuide.d0f9139b.png";